import { Helpers, Utils } from '../../Core';
import { getCmsDeliveryApi as API } from '../../Apis';
import { mocksService } from './GetCmsEmergencyExit.mock';
import dataFields from '../../Types/CmsEmergencyExit.json';
import { EmergencyExit } from '../../Types/internals/CmsEmergencyExit.internals.types';
import { EmergencyExitFormatted } from '../../Types/CmsEmergencyExit.types';

const prepareCall = async () => {
  const { cmsDeliveryIds } = Helpers.getConstants();
  const { EMERGENCY_EXIT } = cmsDeliveryIds as {
    [key: string]: string;
  };

  return await API.call.get({
    contentId: EMERGENCY_EXIT,
  });
};

const removeLineBreakAndTags = (string: string) => {
  return string
    ? string.replace(/\\n|\n/g, '').replace(/<[^>]*>/g, '')
    : string;
};

const addSquareBracketsToString = (string: string) => {
  return ['[', string, ']'].join('');
};

const indetifierSubtopics = (string: string) => {
  const meanString = string.split('-');
  const regex = /[a-zA-Z].*[0-9]|[0-9].*[a-zA-Z]/;
  return regex.test(meanString[meanString.length - 1]);
};

const handleSucessFinalResponseFunction = (
  contentRaw: EmergencyExit,
): EmergencyExitFormatted => {
  const { content } = contentRaw;
  const {
    title,
    'attention-bold': attentionBold,
    attention,
    space,
    mandatory,
    responsibility,
    'emergency-bold': emergencyBold,
    'emergency-exception-bold': emergencyExceptionBold,
  } = content;
  const emergencyContent: EmergencyExitFormatted['content']['thirdText'] = [];
  const emergencyExceptionContent: EmergencyExitFormatted['content']['fourthText'] =
    [];
  const identificationContent: EmergencyExitFormatted['content']['fifthText'] =
    [];

  Object.keys(content).forEach((key) => {
    let value = content[key as keyof EmergencyExit['content']];
    value = removeLineBreakAndTags(value);
    const upperKey = key.toUpperCase();

    if (upperKey.startsWith('EMERGENCY') && !upperKey.includes('EXCEPTION')) {
      emergencyContent.push(value);
    }

    if (upperKey.includes('EXCEPTION')) {
      if (indetifierSubtopics(upperKey)) {
        emergencyExceptionContent[emergencyExceptionContent.length - 1] = `${
          emergencyExceptionContent[emergencyExceptionContent.length - 1]
        }\n${value}`;
      } else {
        emergencyExceptionContent.push(value);
      }
    }

    if (upperKey.startsWith('IDENTIFICATION')) {
      identificationContent.push(value);
    }
  });

  emergencyContent.shift();
  const secondText = emergencyContent[0];
  emergencyContent.shift();

  const attentionBoldFormatted = addSquareBracketsToString(attentionBold);
  const firstText = [
    `${attentionBoldFormatted} ${attention}`,
    space,
    mandatory,
    responsibility,
  ];

  emergencyExceptionContent.shift();
  const popElement = emergencyExceptionContent.pop();
  popElement && identificationContent.unshift(popElement);
  return {
    id: contentRaw.id,
    content: {
      title: addSquareBracketsToString(removeLineBreakAndTags(title)),
      firstText,
      firstSubtitle: addSquareBracketsToString(
        removeLineBreakAndTags(emergencyBold),
      ),
      secondText: secondText,
      thirdText: emergencyContent,
      secondSubtitle: addSquareBracketsToString(
        removeLineBreakAndTags(emergencyExceptionBold),
      ),
      fourthText: emergencyExceptionContent,
      fifthText: identificationContent,
    },
  };
};

export const { machine, Docs } = Utils.genericMachine({
  invokeApiFunction: prepareCall,
  definitionsAPI: API.definitions,
  handleResponse: { handleSucessFinalResponseFunction },
  mocksService,
  dataFields,
});
